import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/puzzle.vue
var s = {
	name: "DtIconPuzzle",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--puzzle"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Puzzle",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [i("g", { "clip-path": `url(#${e.uniqueID}a)` }, [...t[0] || (t[0] = [i("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M9.806 8.251a.99.99 0 0 0 .39-.24l.806-.805a1.7 1.7 0 0 0 .499-1.2V6c0-.436-.167-.873-.5-1.206l-.783-.784a.013.013 0 0 1-.004-.01.1.1 0 0 1 .023-.03.441.441 0 0 1 .143-.086l.005-.002a1.75 1.75 0 1 0-2.267-2.265.444.444 0 0 1-.087.147c-.007.013-.026.035-.041.02l-.78-.78-.004-.005a1.702 1.702 0 0 0-2.411 0l-.762.762c-.23.23-.34.555-.294.877l.001.01c.077.518.507.801.81.925a.75.75 0 0 1-.43 1.43L4.114 5a.75.75 0 0 1-.542-.451c-.124-.304-.408-.734-.926-.811a1.038 1.038 0 0 0-.886.292l-.763.763-.007.008a1.702 1.702 0 0 0 .008 2.404l.783.784a.013.013 0 0 1 .004.01.1.1 0 0 1-.024.03.437.437 0 0 1-.14.086l-.006.003a1.75 1.75 0 1 0 1.76 2.971l.006-.006c.222-.188.394-.429.5-.7a.444.444 0 0 1 .087-.146c.018-.02.035-.022.041-.02l.006.005.778.778a1.702 1.702 0 0 0 1.86.37c.133-.056.274-.154.352-.211l.115-.087.034-.027.006-.005a.505.505 0 0 0 .042-.036l.005-.006.799-.799.004-.004a.99.99 0 0 0 .28-.845c-.074-.494-.478-.764-.777-.877l-.007-.003a.75.75 0 1 1 .765-1.256 1.923 1.923 0 0 1 .126.179c.03.046.055.09.073.122l.014.028c.12.293.386.67.857.745l.008.001a.99.99 0 0 0 .456-.039ZM7.282 2.49c.227.226.548.333.866.285.507-.076.785-.494.903-.797a.747.747 0 0 1 .912-.446.75.75 0 0 1 .063 1.416l-.004.001c-.302.117-.721.394-.797.902-.048.319.059.64.286.867l.784.784a.701.701 0 0 1 .206.494V6a.7.7 0 0 1-.207.498l-.798.8a.37.37 0 0 1-.085-.132.502.502 0 0 0-.037-.08l-.03-.057a4.177 4.177 0 0 0-.096-.162 1.93 1.93 0 0 0-.332-.42 1.75 1.75 0 1 0-1.757 2.962.375.375 0 0 1 .138.086l-.779.78-.015.012a2.87 2.87 0 0 1-.185.133l-.048.027a.7.7 0 0 1-.768-.153l-.784-.784-.008-.006a1.013 1.013 0 0 0-.858-.28c-.507.077-.785.495-.902.798a.75.75 0 0 1-.21.295l-.004.004a.75.75 0 1 1-.764-1.268l.006-.002c.302-.118.722-.395.797-.903a1.013 1.013 0 0 0-.285-.865l-.785-.785a.701.701 0 0 1 0-.996l.007-.007.757-.756a.038.038 0 0 1 .03-.011s.005 0 .01.004a.16.16 0 0 1 .036.028.527.527 0 0 1 .102.167 1.75 1.75 0 0 0 1.274 1.055l.007.001a1.75 1.75 0 0 0 1-3.337.524.524 0 0 1-.167-.102.16.16 0 0 1-.028-.035.049.049 0 0 1-.004-.01.037.037 0 0 1 .01-.031l.763-.763a.701.701 0 0 1 .228-.153.702.702 0 0 1 .765.15l.787.788Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=puzzle.js.map